import { useContext } from "react";
import { AuthContext } from "./auth-context";
import type { AuthContextValue } from "./auth-context";

/**
 * Read authentication state. Throws when used outside AuthProvider — a missing
 * provider is a wiring mistake that should fail loudly rather than silently
 * render an unauthenticated tree.
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider.");
  }
  return context;
}
